import { mockBuilder } from '../../utils/builderHelper.es.js';
import { CheckoutSubmitResponse } from './CheckoutSubmitResponse.es.js';

function aCheckoutSubmitResponse() {
    return mockBuilder(new CheckoutSubmitResponse()).withInvoiceNumber('123');
}

export { aCheckoutSubmitResponse };
